/**
 *  Bomb
 *
 *  Created by Legman on 20/04/2017.
 *
 */

import Common       from "../Common";
import RaceMover    from "../race/RaceMover";

/**
 * @class
 * @extends RaceMover
 */
export default class Bomb extends RaceMover {
    /**
     * @param {RaceCar} owner
     */
    constructor(owner) {
        const temp = new PIXI.Sprite(Common.assets.getTexture("game_powerup_bomb"));
        temp.anchor = new PIXI.Point(0.5, 0.5);
        super(temp);

        this.collisionWidth = 60;
        this.collisionLength = 34;

        /**
         * @member {number}
         */
        this.armDelay = 1;

        /**
         * @member {RaceCar}
         * @protected
         */
        this._owner = owner;

        /**
         * @member {PIXI.particles.Emitter}
         * @protected
         */
        this._emitter = null;

        /**
         * @member {boolean}
         * @private
         */
        this._isEmitterFinished = false;

        /**
         * @member {boolean}
         * @private
         */
        this._armed = false;

        /**
         * @member {boolean}
         * @private
         */
        this._arming = false;

        /**
         * @member {number}
         * @private
         */
        this._armBlinkFrame = 0;

        /**
         * @member {number}
         * @private
         */
        this._armBlinkRate = 8;
    }

    init() {
        this._startDist = this.distance;
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        this._emitter && this._emitter.update(dt);
        if (this._emitter && !this._emitter.emit) {
            if (!this._isEmitterFinished) {
                this._isEmitterFinished = true;

                // delay the destroy by one frame so the particles can fade
                delay(function() {
                    this.destroyNextFrame = true;
                }, 1, this);
            }
        }

        if (this._arming) {
            if (++ this._armBlinkFrame % this._armBlinkRate === 0) {
                this.alpha = !this.alpha ? 1 : 0;
            }
        }

    }

    arm() {
        delay(function() {
            this._armed = true;
            this._arming = false;
            this.alpha = 1;
        }, this.armDelay, this);
        this._arming = true;
    }

    explode() {
        this._armed = false;
        this._view.texture = PIXI.Texture.EMPTY;

        this._createEmitter();
        this._emitter.playOnceAndDestroy();

        this._view.visible && this._playSound();
    }

    _createEmitter() {
        const assets = Common.assets;
        const config = assets.getJSON("particle_emitter_explosion_00");

        const holder = new PIXI.Container();
        holder.scale = new PIXI.Point(2, 2);
        this._view.addChild(holder);

        this._emitter = new PIXI.particles.Emitter(holder, [
            assets.getTexture("particle_explosion_smoke_00"),
            assets.getTexture("particle_explosion_smoke_01"),
            assets.getTexture("particle_explosion_smoke_02")
        ], config);
        this._emitter.emit = false;
    }

    _playSound() {
        Common.audio.playSound(["sfx_bomb_explode_big_00", "sfx_bomb_explode_big_01"]);
    }

    /**
     * @returns {RaceCar}
     */
    get owner() {
        return this._owner;
    }

    /**
     * @returns {boolean}
     */
    get armed() {
        return this._armed;
    }
}